<div class="modal in" tabindex="-1" role="dialog" aria-hidden="true">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title">
                    {{HsLanguageService.getTranslationIgnoreNonExisting('ABOUT_COMPONENT', 'title')}}
                </h4>
                <button type="button" (click)="dismiss()" class="close" data-dismiss="modal"><span
                        aria-hidden="true">&times;</span><span class="sr-only">Close</span></button>
            </div>
            <div class="modal-body" style="overflow-y:auto; text-align: justify;">
                <p>
                    {{HsLanguageService.getTranslationIgnoreNonExisting('ABOUT_COMPONENT.ABOUT_TEXT', 'a')}}
                </p>
                <p>
                    {{HsLanguageService.getTranslationIgnoreNonExisting('ABOUT_COMPONENT.ABOUT_TEXT', 'b')}}
                </p>
                <p>
                    {{HsLanguageService.getTranslationIgnoreNonExisting('ABOUT_COMPONENT.ABOUT_TEXT', 'ca')}}
                    <a href="https://cds.climate.copernicus.eu" target="_blank">Copernicus Climate Data Store</a>
                    {{HsLanguageService.getTranslationIgnoreNonExisting('ABOUT_COMPONENT.ABOUT_TEXT', 'cb')}}
                    <a href="https://doi.org/10.3390/app11031245"
                        target="_blank">{{HsLanguageService.getTranslationIgnoreNonExisting('ABOUT_COMPONENT.ABOUT_TEXT',
                        'cc')}}</a>.
                </p>

            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-primary" (click)="dismiss()" title="Zavřít"
                    data-dismiss="modal">{{HsLanguageService.getTranslationIgnoreNonExisting('COMMON',
                    'close')}}</button>
            </div>
        </div>
    </div>
</div>